import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 8a1 1 0 0 1-1 1H3l-2 2V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6Z" />
  </svg>
);
export default IconCommentFilledSizeXs;
